<template>
  <b-modal
    ref="deleteConfirmation"
    content-class="px-none px-lg-3"
    :id="modalId"
    :title="deleteDisplayName"
    centered
    hide-header-close
    footer-class="text-center"
  >
    {{deletePrompt}}
    <div slot="modal-footer" class="d-flex full-width">
      <b-button
        pill
        variant="danger"
        class="mr-3"
        @click="hideModal"
        aria-label="Cancel delete">
        No
      </b-button>
      <b-button
        pill
        variant="primary"
        @click="onDeleteConfirmed()"
        aria-label="Confirm delete">
        Yes
      </b-button>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: 'DeleteModal',
  props: {
    modalId: {
      type: String,
      required: true,
    },
    deletePrompt: {
      type: String,
      default() {
        return 'Are you sure you want to delete?';
      },
    },
    deleteDisplayName: {
      type: String,
      default() {
        return 'Delete';
      },
    },
  },
  methods: {
    hideModal() {
      this.$refs.deleteConfirmation.hide();
    },
    onDeleteConfirmed() {
      this.$refs.deleteConfirmation.hide();
      this.$emit('deleteConfirmed');
    },
  },
};
</script>
